import { StoreState } from '@/core/models/store.interface';
import { LocationQuery } from 'vue-router';
import { Module } from 'vuex';
import { SettingsGroupKey } from './settings-group-key.interface';
import { SettingsGroupKeyService } from './settings-group-key.service';

const service = new SettingsGroupKeyService();

export interface SettingsGroupKeyState {
   settingsGroupKeys: Array<SettingsGroupKey>;
}

const SettingsGroupKeyStore: Module<SettingsGroupKeyState, StoreState> = {
   namespaced: true,
   state: { settingsGroupKeys: [] },
   getters: { settingsGroupKeys: (state) => state.settingsGroupKeys },
   mutations: {
      SET_SETTINGS_GROUP_KEYS(state, settingsGroupKeys: Array<SettingsGroupKey>) {
         state.settingsGroupKeys = settingsGroupKeys;
      },
   },
   actions: {
      async getSettingsGroupKeys(context, query?: LocationQuery) {
         const response = await service.getSettingsGroupKeys({ ...query, per_page: '9999', page: '1' });
         context.commit('SET_SETTINGS_GROUP_KEYS', response.data);
         return response;
      },
   },
};

export default SettingsGroupKeyStore;
